<template>
  <EMCard
    :title="title ?? ''"
    :border="true"
    :border-hover="false"
    :no-shadow="true"
    :titleUppercase="false"
    class="dashboard-card"
  >
    <EMTable
      :data="data"
      :columns="columns"
      :actions="actions"
      :initialSortKey="props.initialSortKey"
      :initialSortDirection="props.initialSortDirection"
      :page-size="$props.pageSize"
      :deleteAction="deleteAction"
      :navigateFromLine="navigateFromLine"
      :searchable="props.searchable"
      :search-placeholder="t('common.search')"
      :exportable="props.exportable"
      :exportFileFunction="props.exportFileFunction"
      :exportFileName="props.exportFileName"
      :selectable="props.selectable"
      :selectionKey="props.selectionKey as any"
      :emptyMessage="props.emptyMessage"
      :loading="props.loading"
      :max-width="props.maxWidth"
      :min-width="props.minWidth"
      @selection-change="(payload: any) => emit('selection-change', payload)"
    >
      <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </EMTable>
  </EMCard>
</template>

<script setup lang="ts" generic="T extends Record<string, any>">
import EMTable from '@/common/components/ui/table/EMTable.vue';
import type {
  ColumnDefinition,
  SortDirection,
  TableAction,
} from '@/common/components/ui/table/types';
import EMCard from '../card/EMCard.vue';
import { useLocale } from '@/common/composables';

const props = defineProps<{
  title?: string;
  subtitle?: string;
  data: T[];
  columns: ColumnDefinition<T>[];
  actions?: TableAction<T>[];
  initialSortKey?: keyof T | string | null;
  initialSortDirection?: SortDirection;
  searchable?: boolean;
  exportable?: boolean;
  exportFileFunction?: () => void;
  exportFileName?: string;
  deleteAction?: (row: T, rowIndex: number) => void;
  navigateFromLine?: (row: T, rowIndex: number) => void;
  selectable?: boolean;
  selectionKey?: keyof T;
  pageSize?: number;
  emptyMessage?: string;
  loading?: boolean;
  maxWidth?: string;
  minWidth?: string;
}>();

const { t } = useLocale();

const emit = defineEmits<{
  (e: 'selection-change', payload: { selectedIds: unknown[]; selectedRows: T[] }): void;
}>();
</script>

<style scoped>
.dashboard-card {
  padding: 20px 20px 20px 20px;
}
</style>
